'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../../utils/getThemeProp.js');
var colors = require('../../../utils/colors.js');
require('../../../utils/dates.js');
require('../../../utils/numbers.js');
require('../../../utils/PrintComponentGenerator/PrintComponentGenerator.js');
require('../../../utils/strings.js');
require('../../../utils/infiniteScrollCheckStateManager/infiniteScrollCheckStateManager.js');
require('../../../utils/pairedTableComponentGenerator/pairedTableComponentGenerator.js');
require('../../../utils/safeFetch.js');
require('../../../utils/dom.js');

var getColorFrom = function (status) {
    switch (status) {
        case 'met':
            return '#617799'; // gray
        case 'missedOrCanceled':
        case 'canceled':
            return '#31CC97'; // green
        case 'confirmed':
            return '#2196f3'; // blue
        case 'scheduled':
            return '#E03229'; // red
        case 'missed':
            return '#31CC97'; // green
        case 'skipped':
            return '#F6C343'; // yellow
        case 'deleted':
        case 'booked':
        default:
            return '#000000'; // black
    }
};
var getBackgroundColorFrom = function (status, darkness) {
    var color = getColorFrom(status);
    return colors.getRgbColorFromHex(color, darkness);
};
var addSpaceToDelimiter = function (source, delimiter) {
    var regex = new RegExp("[" + delimiter + "]", 'g');
    return source.replace(regex, delimiter + " ");
};

exports.addSpaceToDelimiter = addSpaceToDelimiter;
exports.getBackgroundColorFrom = getBackgroundColorFrom;
exports.getColorFrom = getColorFrom;
